module.exports = __webpack_public_path__ + "static/Distributed_Teams-872016b1dd49ea3d04fcf332015d3cb6.jpg";